import React from "react";
// import { FormattedMessage } from '../../../util/reactIntl';
import Star from './star.svg';
import css from './ReviewsContainer.module.css';

const ReviewsContainer = (props) => {
    const {
        publicData,
        reviews = [],
    } = props;

    const { reviewScore: publicReviewScore, numberOfReviewers: publicNumberOfReviewers } = publicData || {};

    const reviewCount = publicNumberOfReviewers || reviews.length || 0;

    let reviewScore = publicReviewScore / 10;
    if (!publicReviewScore && reviews.length > 0) {
        const totalRating = reviews.reduce((acc, curr) => acc + curr.attributes.rating, 0);
        reviewScore = totalRating / reviews.length;
    }

    const displayScore = reviewScore ? reviewScore.toFixed(1) : '0.0';
    const widthPercent = (reviewScore / 5) * 100;

    const StarFull = (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 14" fill="none">
            <path d="M7.13281 0L8.81667 5.18237H14.2657L9.85735 8.38525L11.5412 13.5676L7.13281 10.3647L2.72442 13.5676L4.40828 8.38525L-0.00011158 5.18237H5.44896L7.13281 0Z" fill="#477BF4" />
        </svg>
    );

    const StarEmpty = (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 14" fill="none">
            <path d="M7.13281 0L8.81667 5.18237H14.2657L9.85735 8.38525L11.5412 13.5676L7.13281 10.3647L2.72442 13.5676L4.40828 8.38525L-0.00011158 5.18237H5.44896L7.13281 0Z" fill="#D9D9D9" />
        </svg>
    );

    return (
        <div className={css.reviewsWrapper}>
            <div className={css.starsAndCount}>
                <div className={css.starWrapper}>
                    <div className={css.starsBase}>
                        {[...Array(5)].map((_, i) => (
                            <span key={i}>{StarEmpty}</span>
                        ))}
                    </div>
                    <div className={css.starsOverlay} style={{ width: `${widthPercent}%` }}>
                        {[...Array(5)].map((_, i) => (
                            <span key={i}>{StarFull}</span>
                        ))}
                    </div>
                </div>

                <div className={css.scoreAndCount}>
                    <span className={css.reviewScore}>{displayScore}</span>
                    <span className={css.reviewCount}>({reviewCount})</span>
                </div>
            </div>
        </div>
    );
};

export default ReviewsContainer;
